import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useSprings, animated } from "@react-spring/web";

const GrowthHelpSection = () => {
  const items = [
    "Найти ключевые точки роста и преодолеть барьеры в разных отделах вашего бизнеса.",
    "Добиться стабильного и прогнозируемого развития.",
    "Усилить личную продуктивность и эффективность вашей команды.",
    "Создать чёткий и рабочий план, который станет основой вашего успеха.",
  ];

  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const springs = useSprings(
    items.length,
    items.map((_, index) => ({
      from: { opacity: 0, transform: "translateY(20px)" },
      to: inView
        ? { opacity: 1, transform: "translateY(0px)" }
        : { opacity: 0, transform: "translateY(20px)" },
      delay: index * 400,
      config: { tension: 120, friction: 14 },
    }))
  );

  return (
    <Box
      ref={sectionRef}
      sx={{
        background: "#000",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        py: { xs: 6, md: 8 },
        px: { xs: 3, md: 6 },
        textAlign: "center",
        minHeight: { xs: "auto", md: "80vh" },
      }}
    >
      <Grid
        container
        spacing={4}
        justifyContent="center"
        alignItems="center"
        sx={{ width: "100%" }}
      >
        <Grid item xs={12} md={8}>
          <Box
            sx={{
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h4"
              fontWeight="bold"
              sx={{
                lineHeight: 1.3,
                mb: { xs: 3, md: 10 },
                fontSize: {
                  xs: "2.1rem",
                  md: "3.3rem",
                },
              }}
            >
              Я помогу вам:
            </Typography>
            <List sx={{ textAlign: "center" }}>
              {springs.map((style, index) => (
                <animated.div key={index} style={style}>
                  <ListItem
                    sx={{
                      justifyContent: "center",
                      mb: { xs: 0, md: 4 },
                    }}
                  >
                    <ListItemIcon>
                      <CheckCircleIcon sx={{ color: "#bba8e0" }} />
                    </ListItemIcon>
                    <ListItemText primary={items[index]} />
                  </ListItem>
                </animated.div>
              ))}
            </List>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default GrowthHelpSection;
